export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$',
    address: '',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
